import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ButtonGroup, IconButton } from "@mui/material";
import AdvertisementService from "../../../services/advertisements";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloseIcon from '@mui/icons-material/Close';  // Importa el icono de la X
import { Toast } from "../../../utils/alerts";

const columns = [
  { id: "", label: "#", minWidth: 50, align: "left" },
  { id: "trabajador", label: "Trabajador", minWidth: 200, align: "left" },
  { id: "actions", label: "Acciones", minWidth: 120, align: "left" },
];

const BodyUserToFolder = (props) => {
  const { usuarioCarpeta, usuariosAgregados, setUsuariosAgregados,getUsersByCarpeta,setOpenModalLoader,carpetaSeleccionada ,setInfoUsuarioLA} = props;

  // Función para eliminar un usuario de la lista
  const handleDeleteUser = (userToDelete) => {
    setUsuariosAgregados(usuariosAgregados.filter(user => user.value !== userToDelete.value));
    setInfoUsuarioLA(null);
  };

  const handleDeleteFromBackend = async (user) => {
    
    if (!user?.persona_id || !user?.carpetaArea_id) {
      Toast.fire({
        icon: "warning",
        title: "Datos insuficientes para eliminar.",
      });
      return;
    }
  
    setOpenModalLoader(true);
  
    try {
      const response = await AdvertisementService.deleteUserFromCarpeta({
        persona_id: user.persona_id,
        carpetaArea_id: user.carpetaArea_id,
      });
  
      if (response.status === 200) {
        Toast.fire({
          icon: "success",
          title: response.data.message || "Usuario eliminado.",
        });
        getUsersByCarpeta();
      } else {
        Toast.fire({
          icon: "error",
          title: response.data.message || "No se pudo eliminar.",
        });
      }
    } catch (error) {
      console.error(error);
      Toast.fire({
        icon: "error",
        title: "Error al eliminar el usuario.",
      });
    } finally {
      setOpenModalLoader(false);
    }
  };

  // Combina los usuarios de usuarioCarpeta y los usuariosAgregados
  const combinedUsers = [
    ...(usuarioCarpeta || []),
    ...(usuariosAgregados || []).map(user => ({ ...user, trabajador: user.children }))
  ];
  return (
    <div className="page-body-main">
      <div className="page-body__table" style={{ overflow: "hidden" }}>
        <div className="page-body-table">
          <TableContainer className="table-height">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Mostrar todos los usuarios combinados */}
                {combinedUsers?.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{user.trabajador}</TableCell>
                    <TableCell>
                      <ButtonGroup disableElevation variant="contained" aria-label="Disabled elevation buttons">
                        {user.value ? (
                          <IconButton
                            size="small"
                            color="error"
                            title="Cancelar"
                            onClick={() => handleDeleteUser(user)}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          <IconButton
                            size="small"
                            color="error"
                            title="Eliminar Usuario"
                            onClick={() => handleDeleteFromBackend(user)}
                          >
                            <DeleteForeverIcon fontSize="small" />
                          </IconButton>
                        )}
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default BodyUserToFolder;
